export default __webpack_public_path__ + "emptyInbox.3f1f167170a6caa37e8bef0b81a70683.svg";